import { Application } from '@nutrien/ddc-fe-logging-pwa';

import appConfig from '../../../config/app.config.json';
import packageJson from '../../package.json';

export const application: Application = {
  platform: appConfig.context.toLowerCase(),
  project: appConfig.projectName.toLowerCase(),
  name: `${appConfig.context}-${appConfig.appName}-web`.toLowerCase(),
  version: packageJson.version,
};
